<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Сторис</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                class="col-form-label"
                                sm="3">
                                Включено
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    class=""
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="stories.enabled" />
                            </CCol>
                        </CRow>

                        <CInput
                            v-model="stories.description"
                            horizontal
                            label="Описание"
                            placeholder="Введите описание"/>

                        <CInput
                            v-model="stories.show_time"
                            horizontal
                            label="Время показа (милисекунды)"
                            placeholder="Введите время показа (милисекунды)" />

                        <label>Изображение <span class='label' > * </span></label>
                        <CInputFile
                            ref="picture"
                            horizontal
                            @change="selectPicture" />

                        <CRow v-if="stories.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="pictureUrl(stories.picture)"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>

                    </CForm>

                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import StoriesTabLinks from '@/components/stories/StoriesTabLinks';
    import StoriesPictures from '@/components/stories/StoriesPictures';

    export default {

        name: 'StoriesEdit',

        components: {
            StoriesTabLinks,
            StoriesPictures
        },

        data: () => ({
            stories: {
                id: '',
                enabled: false,
                description: '',
                show_time: '',
                picture: null,
            },
            selectedPicture: null,
            isCreated: false,
        }),

        computed: {},

        async mounted() {
            await this.fetch();
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            pictureUrl(picture) {
                return picture ? process.env.VUE_APP_STATIC_BASE_URL + '/' + picture : '';
            },
            async fetch() {
                try {
                    const stories = await this.axios.get(`/stories-settings`);
                    if (stories.data.id) {
                        this.stories = stories.data;
                    }
                } catch (error) { console.log(error); }
            },
            async save() {
                try {
                    if (this.selectedPicture) {
                        let formData = new FormData();
                        formData.append('file', this.selectedPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.stories.picture = uploadPicture.data.filename;
                    }
                    this.stories.show_time = +this.stories.show_time;
                    await this.axios.post(`/stories-settings`,this.stories);

                    this.goBack();
                } catch (error) {
                    console.log(error);
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router.push({ path: `/stories` });
            },
        },
    };
</script>
<style>
</style>
